import { useEffect } from 'react';
import Modal from 'react-modal';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const ModalComponent = (props) => {
  const {
    children,
    isOpen,
    setIsOpen,
    maxWidth = 700,
    height = 'auto',
    onAfterClose = () => {},
    overlayClassName = 'react-modal-overlay',
    shouldCloseOnOverlayClick = true,
    style = {},
    additionalOpenAction,
    className = '',
    closeFunctionality,
    notShowCloseButton,
  } = props;

  const closeModal = (event) => {
    event?.stopPropagation?.();
    setIsOpen(false);
  };

  const overlayElement = (props, contentElement) => {
    const { onMouseDown, onClick, ...rest } = props;

    return (
      <div
        {...rest}
        onMouseDown={(event) => {
          event.stopPropagation();
          if (shouldCloseOnOverlayClick && event.target === event.currentTarget) {
            event.preventDefault();
          }
          onMouseDown?.(event);
        }}
        onClick={(event) => {
          event.stopPropagation();
          onClick?.(event);
        }}
      >
        {contentElement}
      </div>
    );
  };

  useEffect(() => {
    if (isOpen && additionalOpenAction) {
      additionalOpenAction();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      closeTimeoutMS={300}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      overlayClassName={overlayClassName}
      className={`react-modal-content modal-slide-text ${className}`}
      onRequestClose={closeModal}
      overlayElement={overlayElement}
      shouldFocusAfterRender={true}
      style={{
        content: {
          width: '90%',
          maxWidth: `${maxWidth}px`,
          height,
          ...style,
        },
      }}
      onAfterClose={onAfterClose}
    >
      {isOpen && !notShowCloseButton && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (closeFunctionality) {
              closeFunctionality();
            } else {
              setIsOpen(false);
            }
          }}
          className='circle-button general-button hovered-button modal-close-button z-max action-state-hover'
        >
          <span className='icon-close paragraph-p5' />
        </button>
      )}
      {children}
      <ReactTooltip
        effect={'solid'}
        id={'modal-tooltip'}
        className={'header-tooltip'}
        arrowColor={'transparent'}
        place={'top'}
      />
    </Modal>
  );
};

export default ModalComponent;
